import "./fonts.css"
import "./reset.css"
import { ThemeProvider } from "theme-ui"
import React from "react"
import theme from "../gatsby-plugin-theme-ui"

interface LayoutProps {
  children: React.ReactNode
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>
}
